import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

export const NodesContextProviderDefaultProps = {
  ...ChildrenDefaultProps,
  depth: null,
};

export const NodesContextProviderPropTypes = {
  ...ChildrenPropTypes,
  depth: PropTypes.number,
};
